// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"370cafde","239":"be0d2136","455":"c0144b18"}[chunkId] + ".chunk.js";
};